import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import ROICalculator from './components/ROICalculator';
import PaymentPlanComparison from './components/PaymentPlanComparison';
import DeveloperPerformance from './components/DeveloperPerformance';
import RiskAssessmentTool from './components/RiskAssessmentTool';
import MarketAppreciation from './components/MarketAppreciation';

const stats = [
  { value: 'AED 1.2M', label: 'Dubai Avg Off-Plan Price', icon: 'Home' },
  { value: '6.8%', label: 'Avg Rental Yield', icon: 'TrendingUp' },
  { value: '+22%', label: 'Dubai Growth 2024', icon: 'BarChart2' },
  { value: '2,400+', label: 'Active Off-Plan Projects', icon: 'Building2' }
];

const OffPlanAnalyticsROI = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, #0A1628 0%, #0D1F3C 50%, #0A1628 100%)' }}>
      {/* Header */}
      <div className="sticky top-0 z-50 px-4 py-3" style={{ background: 'rgba(10,22,40,0.95)', borderBottom: '1px solid rgba(0,212,255,0.15)', backdropFilter: 'blur(12px)' }}>
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-sm" style={{ color: '#6B9EC4' }}>
            <Icon name="ArrowLeft" size={16} color="#6B9EC4" />
            Back to Home
          </button>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full animate-pulse" style={{ background: '#00D4FF' }} />
            <span className="text-xs font-medium" style={{ color: '#00D4FF' }}>LIVE MARKET DATA</span>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-12">
        {/* Hero */}
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium mb-4" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)', color: '#00D4FF' }}>
            <span>📊</span>
            <span>OFF-PLAN ANALYTICS & ROI</span>
          </div>
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-4" style={{ fontFamily: "'Orbitron', sans-serif", color: '#E8F4FF' }}>
            <span style={{ color: '#00D4FF', textShadow: '0 0 30px rgba(0,212,255,0.4)' }}>UAE Off-Plan</span>
            <br />
            <span>Investment Intelligence</span>
          </h1>
          <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#6B9EC4' }}>
            Advanced ROI calculators, payment plan analysis, developer performance tracking, and market appreciation projections — all UAE-specific with AED currency and local market data.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
          {stats?.map((s, i) => (
            <div key={i} className="text-center p-4 rounded-xl" style={{ background: 'rgba(10,22,40,0.8)', border: '1px solid rgba(0,212,255,0.2)' }}>
              <div className="w-8 h-8 rounded-lg flex items-center justify-center mx-auto mb-2" style={{ background: 'rgba(0,212,255,0.1)' }}>
                <Icon name={s?.icon} size={16} color="#00D4FF" />
              </div>
              <div className="text-xl md:text-2xl font-bold" style={{ fontFamily: "'JetBrains Mono', monospace", color: '#00D4FF' }}>{s?.value}</div>
              <div className="text-xs" style={{ color: '#6B9EC4' }}>{s?.label}</div>
            </div>
          ))}
        </div>

        {/* ROI Calculator — Full Width */}
        <div className="mb-8">
          <ROICalculator />
        </div>

        {/* Payment Plan + Market Appreciation */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
          <PaymentPlanComparison />
          <MarketAppreciation />
        </div>

        {/* Developer Performance — Full Width */}
        <div className="mb-8">
          <DeveloperPerformance />
        </div>

        {/* Risk Assessment */}
        <div className="mb-8">
          <RiskAssessmentTool />
        </div>

        {/* CTA */}
        <div className="rounded-2xl p-6 md:p-8 text-center" style={{ background: 'rgba(10,22,40,0.9)', border: '1px solid rgba(0,212,255,0.2)' }}>
          <h3 className="text-xl font-bold mb-2" style={{ color: '#E8F4FF' }}>Ready to Invest in UAE Off-Plan?</h3>
          <p className="text-sm mb-6" style={{ color: '#6B9EC4' }}>Browse RERA-verified off-plan projects with full compliance data and developer track records.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button onClick={() => navigate('/search-results?location=Dubai&filter=off-plan')}
              className="px-6 py-3 rounded-xl font-semibold text-sm" style={{ background: '#00D4FF', color: '#0A1628' }}>
              Browse Off-Plan Projects
            </button>
            <button onClick={() => navigate('/rera-compliance-intelligence')}
              className="px-6 py-3 rounded-xl font-semibold text-sm" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)', color: '#00D4FF' }}>
              Check RERA Compliance
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OffPlanAnalyticsROI;
